module.exports = __webpack_public_path__ + "img/icon-oasis-part-en.e8304539.png";